function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'emu-blue': 'rgb(148, 220, 255)','stealth-black': 'rgb(0, 0, 0)','electric-blue': 'rgb(100, 196, 220)','pillar-box-red': 'rgb(246, 31, 31)','sky-blue': 'rgb(8, 68, 196)','stone': 'rgb(215, 220, 204)','light-graphite-blue': 'rgb(156, 193, 242)','black-green': 'rgb(69, 207, 116)','fuschia': 'rgb(240, 188, 196)','navy-blue': 'rgb(8, 12, 44)','racing-green': 'rgb(24, 68, 52)','british-racing-green': 'rgb(34, 152, 145)','sangria-red': 'rgb(80, 2, 7)','carbon-black': 'rgb(72, 68, 76)','gloss-black': 'rgb(0, 0, 0)','racing-white': 'rgb(236, 236, 244)','solarbeam-yellow': 'rgb(240, 204, 68)','denim-blue': 'rgb(4, 140, 196)','magno-green': 'rgb(64, 92, 84)','gunmetal-grey': 'rgb(140, 140, 142)','avocado-green': 'rgb(104, 108, 52)','flamingo-pink': 'rgb(232, 68, 84)','snow-white': 'rgb(255, 255, 255)','onyx-black': 'rgb(0, 0, 0)','gem-blue': 'rgb(8, 196, 196)','bumblebee-yellow': 'rgb(255, 180, 44)','galaxy-grey': 'rgb(48, 44, 44)','mountain-green': 'rgb(60, 116, 116)','emerald-green': 'rgb(60, 116, 116)','midnight-blue': 'rgb(16, 44, 76)','space-black': 'rgb(48, 44, 44)','white-orange': 'rgb(252, 148, 76)','black-orange': 'rgb(252, 148, 76)','gloss-white': 'rgb(255, 255, 255)','black-ice-dye': 'rgb(57, 57, 57)','matt-black': 'rgb(57, 57, 57)','matte-portaro-grey': 'rgb(64, 68, 84)','ano-harbour-blue': 'rgb(68, 110, 169)','matte-black': 'rgb(57, 57, 57)','matte-chalk': 'rgb(212, 212, 216)','matt-blue': 'rgb(92, 199, 249)','matt-orange': 'rgb(255, 138, 0)','dark-orange': 'rgb(255, 138, 0)','matt-acid-yellow': 'rgb(255, 229, 0)','gloss-candy-red': 'rgb(246, 31, 31)','gloss-blue': 'rgb(0, 91, 211)','gloss-grey': 'rgb(128, 128, 128)','baby-blue': 'rgb(0, 216, 226)','ice-white': 'rgb(255, 255, 255)','skyline': 'rgb(4, 148, 148)','ink-grey': 'rgb(164, 164, 170)','dark-night': 'rgb(0, 0, 0)','midnight-black': 'rgb(0, 0, 0)','midnight-black-57-61cm': 'rgb(0, 0, 0)','ultraviolet': 'rgb(165, 77, 207)','mint': 'rgb(59, 196, 236)','graphite-black': 'rgb(0, 0, 0)','sandstone-grey': 'rgb(128, 128, 128)','ocean-blue': 'rgb(0, 84, 119)','ocean-blue-54-58cm': 'rgb(0, 84, 119)','echo-blue': 'rgb(0, 84, 119)','dark-olive-black': 'rgb(28, 36, 40)','carbon-grey-black': 'rgb(116, 124, 132)','ice-blue': 'rgb(231, 238, 239)','army-green': 'rgb(134, 159, 148)','ink-green': 'rgb(116, 131, 124)','charcoal-grey': 'rgb(97, 99, 112)','cream': 'rgb(222, 209, 158)','purple-blue': 'rgb(102, 118, 210)','pearl-white': 'rgb(208, 203, 188)','sprint-red': 'rgb(239, 40, 50)','titanium-silver': 'rgb(230, 231, 228)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
